import "./HomePage.less";

import { Button } from "antd";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import * as scrollToElement from "scroll-to-element";

import { ContentView } from "components/views/general";
import * as Api from "lib/api";
import { CancellationToken } from "lib/api/base";
import { ContentSection } from "lib/data";
import { IBaseProps } from "lib/data/interfaces";
import { StateService } from "lib/services";

import {
	// Button,
	SearchBar
} from "components/general";


interface IHomePageProps extends IBaseProps, RouteComponentProps<any> {

}

interface IHomePageState {
	title: string;
	backgroundUrl: string;
}


export class HomePage extends React.Component<IHomePageProps, IHomePageState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();


	private sections: ContentSection[] = [];

	constructor(props: IHomePageProps) {

		super(props);

		this.state = {
			title: "Government Directory",
			backgroundUrl: "",
		};
	}

	public async componentWillMount() {
		const content = await Api.ContentManagementApi.getHomeContent();

		if (content) {
			this.sections = content.sections;
			StateService.setCancelableState(() => this.setState({ title: content.title, backgroundUrl: content.backgroundURL }), this.apiCancellationToken);
		}
	}

	public async componentWillReceiveProps(_newProps: IHomePageProps) {
		const content = await Api.ContentManagementApi.getHomeContent();

		if (content) {
			this.sections = content.sections;
			StateService.setCancelableState(() => this.setState({ title: content.title, backgroundUrl: content.backgroundURL }), this.apiCancellationToken);
		}
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}


	public componentDidMount() {

		// Scroll To Any Same Page Anchor Specified In URL
		this.scrollToSamePageAnchor();
	}

	public componentDidUpdate() {

		// Scroll To Any Same Page Anchor Specified In URL
		this.scrollToSamePageAnchor();
	}

	public render() {

		return (
			<div className="home-page">
				<section className="background" />

				<section className="main">

					<section className="content">
						<header className="introduction">

							<div className="logo-wrapper">
								<img src="https://rules.wyo.gov/assets/images-custom/wyominglogo-whitea.png" />
							</div>

							<h1>{this.state.title}</h1>

						</header>

						<div className="spacer-25-h" />

						<SearchBar placeholder="What are you looking for today?" onSearch={this.onDirectorySearched} autoFocus={true} />

						<div className="spacer-10-h" />

						{/* <Button size="medium" isWide={true} hasBorder={true} destination="section">View Directory</Button> */}
						<Button
							size="large"
							onClick={() => this.props.history.push("/section")}
							type="ghost"
							className="view-directory-button"
						>
							View Directory
						</Button>
					</section>

				</section>

				<section className="content-sections">
					<ContentView sections={this.sections} />
				</section>

			</div>
		);
	}

	private onDirectorySearched = (searchString: string) => {

		// Redirect To Search Page
		this.props.history.push(`/search?q=${searchString}`);
	}

	private scrollToSamePageAnchor = () => {

		// Check Hash
		if (location.hash !== "" && location.hash.startsWith("#")) {

			scrollToElement(location.hash, {

				offset: -90,
				ease: "in-out-quart",
				duration: 1250
			});
		}
		else if (document.scrollingElement !== null && (document.scrollingElement.scrollTop !== 0 || document.scrollingElement.scrollLeft !== 0)) {

			// Scroll To Top-Left
			scrollToElement(".home-page", {

				offset: 0,
				align: "top",
				ease: "in-out-quart",
				duration: 1250
			});
		}
	}
}
